var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrconsulta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_369",
    "data-name": "Group 369",
    xmlns: "http://www.w3.org/2000/svg",
    width: 261.802,
    height: 36.913,
    viewBox: "0 0 261.802 36.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M564.35,540.995v36.1h-7.929v-2.44a10.35,10.35,0,0,1-7.685,3.253c-6,0-9.67-4.783-9.67-10.856,0-8.609,5.75-13.531,13.3-13.531a20.733,20.733,0,0,1,3.865.43V540.995Zm-12.665,30.216a6.788,6.788,0,0,0,4.543-2.006v-8.8a12.043,12.043,0,0,0-2.755-.287c-4.013,0-6.238,2.293-6.238,5.976C547.236,569.348,549.027,571.211,551.685,571.211Z",
    transform: "translate(-539.067 -540.995)",
    fill: "#0057fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M565.649,544.818v7.172a13.746,13.746,0,0,0-3.045-.333,11.774,11.774,0,0,0-6.671,2.053v14.252h-8.122v-22.9h7.979v2.436a12.122,12.122,0,0,1,7.251-2.963A10.239,10.239,0,0,1,565.649,544.818Z",
    transform: "translate(-516.484 -531.862)",
    fill: "#0057fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M555.792,557.056c0-7.27,5.027-12.579,12.909-12.579a14.806,14.806,0,0,1,6.717,1.483v6.456a12.452,12.452,0,0,0-5.174-1.053c-4.013,0-6.091,2.107-6.091,5.453,0,3.3,2.128,5.166,5.85,5.166a13.786,13.786,0,0,0,5.607-1.15V567.1a16.873,16.873,0,0,1-8.265,1.817C559.948,568.915,555.792,564.085,555.792,557.056Z",
    transform: "translate(-495.871 -532.002)",
    fill: "#0057fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M562.256,556.672c0-6.932,5.317-12.2,13.1-12.2,8.219,0,13.152,4.973,13.152,12.2,0,6.886-5.224,12.242-13.152,12.242C567.236,568.915,562.256,563.845,562.256,556.672Zm18.078,0c0-3.633-1.737-5.5-4.98-5.5-3,0-4.976,2.153-4.976,5.5,0,3.54,1.788,5.5,4.976,5.5C578.4,562.172,580.334,560.069,580.334,556.672Z",
    transform: "translate(-479.177 -532.002)",
    fill: "#0057fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M595.326,555.526V568.1h-8.172V556.816c0-3.586-1.157-4.926-3.916-4.926a7.438,7.438,0,0,0-4.349,1.626V568.1H570.72V545.2H578.7v2.39a13.164,13.164,0,0,1,7.929-3.11C592.571,544.477,595.326,548.113,595.326,555.526Z",
    transform: "translate(-457.317 -532.002)",
    fill: "#0057fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M578.83,566.845v-5.739a24.915,24.915,0,0,0,9.376,1.817c2.708,0,4.546-.19,4.546-1.53,0-1.2-.727-1.58-4.45-1.913-6.865-.527-9.183-2.963-9.183-7.459,0-5.023,5.123-7.556,11.167-7.556a21.245,21.245,0,0,1,8.8,1.77v5.6a25.4,25.4,0,0,0-7.929-1.483c-2.178,0-4.206.093-4.206,1.433,0,1.2.917,1.483,4.4,1.867,6.477.67,9.232,3.059,9.232,7.7,0,4.83-3.722,7.6-11.411,7.6A25.437,25.437,0,0,1,578.83,566.845Z",
    transform: "translate(-436.371 -532.036)",
    fill: "#0057fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M610.64,544.678v22.9h-7.929v-2.39a12.457,12.457,0,0,1-7.785,3.2c-5.944,0-8.7-3.682-8.7-11.1V544.678H594.4v11.429c0,3.586,1.014,4.83,3.769,4.83a7.3,7.3,0,0,0,4.3-1.627V544.678Z",
    transform: "translate(-417.275 -531.483)",
    fill: "#0057fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M594.572,540.995h8.169v26.681c0,1.909.484,3.536,2.952,3.536a8.985,8.985,0,0,0,2.9-.476V576.9a14.479,14.479,0,0,1-6.091,1c-5.607,0-7.928-3.443-7.928-8.9Z",
    transform: "translate(-395.714 -540.995)",
    fill: "#0057fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    d: "M617.111,565.007v6.313a15.578,15.578,0,0,1-6.671,1.387c-8.508,0-11.024-5.023-11.024-11.859V543.009h8.172v5.979h9.283v6.166h-9.283v6.026c0,3.06.82,4.783,4.883,4.783A11.021,11.021,0,0,0,617.111,565.007Z",
    transform: "translate(-383.204 -535.794)",
    fill: "#0057fd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 5.023,
    cy: 4.773,
    rx: 5.023,
    ry: 4.773,
    transform: "translate(46.354 26.505)",
    fill: "#fcaf17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M629.957,559.324v-13.27a31.4,31.4,0,0,0-9.157-1.576c-9.573,0-15.567,4.973-15.567,13.536,0,6.119,3.672,10.9,9.329,10.9a10.2,10.2,0,0,0,7.588-3.253v2.44h7.831v-8.778Zm-8.047.889a6.464,6.464,0,0,1-4.349,1.96c-2.612,0-4.16-1.867-4.16-5.116,0-3.683,2.271-5.98,6.528-5.98.677,0,1.354.05,1.981.1Z",
    transform: "translate(-368.18 -532.002)",
    fill: "#0057fd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrconsulta);
export default __webpack_public_path__ + "static/media/drconsulta.f9c54838.svg";
export { ForwardRef as ReactComponent };